import { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { HomeNav } from '@/pages/landing/home/HomeNav';
import { HomeFooter } from '@/pages/landing/home/HomeFooter';
import '@/pages/landing/home/home.css';
import './marketing.css';

interface LandingLayoutProps {
  children: ReactNode;
  /** Accepted for API compatibility; the shell has one navbar style. */
  transparentHeader?: boolean;
}

// Archivo, the typeface of the landing, for every marketing page.
const ARCHIVO_CSS = 'https://fonts.googleapis.com/css2?family=Archivo:wght@400;600;700;800;900&display=swap';

/**
 * LandingLayout: the shell of every marketing page (pricing, industries, comparisons, templates, about, blog, legal). It is the landing page's own
 * scope (`.cc-home`: navy, yellow, Archivo), its nav and its footer, so a visitor who clicks Start free never leaves the brand. The content pages
 * keep their Tailwind markup; marketing.css re-expresses their headings, links and primary buttons in the landing's tokens (and only here, so the
 * app's blue is untouched inside the product).
 */
export function LandingLayout({ children }: LandingLayoutProps) {
  return (
    <div className="cc-home mk">
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link rel="stylesheet" href={ARCHIVO_CSS} />
      </Helmet>
      <HomeNav home={false} />
      <main className="mk-main">{children}</main>
      <HomeFooter home={false} />
    </div>
  );
}
